var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingTierEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:network-enterprise",
    clipPath: "url(#clip0_1465_124954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9609 8.12488C20.5844 6.28149 19.5798 4.62589 18.1186 3.44065C16.6575 2.25542 14.8302 1.614 12.9488 1.62589C11.0674 1.63779 9.24847 2.30224 7.80239 3.50585C6.35632 4.70947 5.37277 6.37763 5.01961 8.22563C3.52003 8.49255 2.17489 9.31166 1.24946 10.5214C0.324035 11.7312 -0.114508 13.2438 0.0203199 14.761C0.155148 16.2782 0.853558 17.6898 1.97782 18.7174C3.10208 19.745 4.57059 20.3141 6.09374 20.3124H6.49999V18.6874H6.09374C4.93394 18.6904 3.81847 18.2421 2.98336 17.4372C2.14826 16.6324 1.65905 15.5342 1.61925 14.3751C1.57945 13.216 1.99219 12.0869 2.77012 11.2267C3.54806 10.3665 4.63015 9.84267 5.78742 9.76613L6.46749 9.71982L6.54061 9.04301C6.7047 7.53119 7.39413 6.12489 8.48871 5.06924C9.5833 4.01358 11.0136 3.37552 12.5304 3.26626C14.0472 3.157 15.5542 3.58348 16.7888 4.47135C18.0234 5.35922 18.9072 6.65219 19.2863 8.12488H20.9609Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.75 9.75H14.625C14.194 9.75 13.7807 9.92121 13.476 10.226C13.1712 10.5307 13 10.944 13 11.375V14.625H9.75C9.31902 14.625 8.9057 14.7962 8.60095 15.101C8.29621 15.4057 8.125 15.819 8.125 16.25V24.375H24.375V11.375C24.375 10.944 24.2038 10.5307 23.899 10.226C23.5943 9.92121 23.181 9.75 22.75 9.75ZM9.75 22.75V16.25H13V22.75H9.75ZM22.75 22.75H14.625V11.375H22.75V22.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.25 13H17.875V16.25H16.25V13ZM19.5 13H21.125V16.25H19.5V13ZM16.25 17.875H17.875V21.125H16.25V17.875ZM19.5 17.875H21.125V21.125H19.5V17.875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1465_124954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingTierEnterprise);
export default __webpack_public_path__ + "static/media/billing-tier-enterprise.37744c5eee3e76f1ef429af994a09a17.svg";
export { ForwardRef as ReactComponent };